import React, { useEffect, useRef } from 'react';
import CustomDataFeed from './CustomDataFeed';
import { customIndicatorsGetter } from './customIndicators';
import { customIndicatorsGetter as volatilityIndicatorGetter } from './volatility_indicator';
import { customIndicatorsGetter as srIndicatorGetter } from './SR_indicator';
import { gexIndicator as gexIndicatorGetter } from './Raw GEX';
import processSRData from './SR_series';
import useStore from '../Store/market_greeks_data_store';
import { normalizeMarketAIData } from '../MS_AI/normalizeMarketAIData';



const AdvancedMarketStateDashboard = () => {
  const spxData = useStore((state) => state.spxData);
  const spxGexData = useStore((state) => state.spxGexData);
  const vvixData = useStore((state) => state.vvixData);
  const topStrikesData = useStore((state) => state.topStrikes);
  const setOriginalSRData = useStore((state) => state.setOriginalSRData);
  const originalSRData = useStore((state) => state.originalSRData);
  const chartWidget = useRef(null);

  // Determine if the device is mobile
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const hasAllData =
      spxData.length > 60 &&
      spxGexData.length > 60 &&
      vvixData.length > 60;

    if (hasAllData) {
      normalizeMarketAIData(); // → Generates features and saves CSV
    }
  }, [spxData, spxGexData, vvixData]);


  useEffect(() => {
    if (topStrikesData.length > 0) {
      const { topCallStrikes, topPutStrikes } = processSRData(topStrikesData);
      setOriginalSRData('topCallStrikes', topCallStrikes);
      setOriginalSRData('topPutStrikes', topPutStrikes);
    }
  }, [topStrikesData, setOriginalSRData]);

  useEffect(() => {
    if (
      spxData.length > 0 &&
      spxGexData.length > 0 &&
      vvixData.length > 0 &&
      Object.keys(originalSRData).length > 0
    ) {
      loadChartWithIndicators(spxGexData, vvixData, originalSRData);
    }



    return () => {
      if (chartWidget.current) {
        const chart = chartWidget.current.activeChart();
        chart.onVisibleRangeChanged().unsubscribeAll(this);
        chart.crossHairMoved().unsubscribeAll(this);
      }
    };
  }, [spxData, spxGexData, vvixData, originalSRData]);

  const loadChartWithIndicators = (spxGexData, vvixData, srLevelsData) => {
    const dataFeed = new CustomDataFeed();

    const widget = new window.TradingView.widget({
      container: 'chartContainer',
      library_path: '/charting_library/',
      datafeed: dataFeed,
      symbol: 'SPX',
      interval: '1D',
      autosize: true,
      theme: 'Dark',
      overrides: {
          // 'paneProperties.background': '#000000',
          // 'paneProperties.backgroundType': 0,  // 0 for solid, 1 for gradient
          "paneProperties.backgroundGradientStartColor": "#000000",
          "paneProperties.backgroundGradientEndColor": "#000000",
          'scalesProperties.textColor': '#FFFFFF',
          'toolbarProperties.background': '#000000',
          'toolbarProperties.separator': '#444444',
      },
      disabled_features: isMobile
        ? [
            'scroll_past_end',
            'create_volume_indicator_by_default',
            'control_bar',
            'header_widget',
            'left_toolbar',
            'timeframes_toolbar',
            'edit_buttons_in_legend',
            'context_menus',
            'control_bar',
            'border_around_the_chart',
          ]
        : ['scroll_past_end', 'create_volume_indicator_by_default'],

      enabled_features: [
        'use_localstorage_for_settings',
        'save_chart_properties_to_local_storage',
        'canvas_support',  // Add this
        'chart_property_page_style',  // And this
    ],
      custom_indicators_getter: async (PineJS) => {
        const customIndicators = await customIndicatorsGetter(PineJS);
        const volatilityIndicators = await volatilityIndicatorGetter(PineJS);
        const srIndicators = await srIndicatorGetter(PineJS);
        const gexIndicator = await gexIndicatorGetter(PineJS);

        return [...customIndicators, ...volatilityIndicators, ...srIndicators, ...gexIndicator];
      },
    });

    widget.onChartReady(() => {
      const chart = widget.activeChart();
          // Add the CSS custom properties here
      // ⛔️ Kill gridlines (same overrides you used on the other chart)
      widget.applyOverrides({
        "paneProperties.horzGridProperties.color": "rgba(0,0,0,0)",
        "paneProperties.vertGridProperties.color": "rgba(0,0,0,0)",
        "mainSeriesProperties.style": 1, // candles
        "mainSeriesProperties.candleStyle.upColor": "#089981",        // neon green
        "mainSeriesProperties.candleStyle.downColor": "#FF4D4D",      // bright red
        "mainSeriesProperties.candleStyle.drawWick": true,
        "mainSeriesProperties.candleStyle.drawBorder": true,
        "mainSeriesProperties.candleStyle.borderUpColor": "#089981",
        "mainSeriesProperties.candleStyle.borderDownColor": "#FF4D4D",
        "mainSeriesProperties.candleStyle.wickUpColor": "#089981",
        "mainSeriesProperties.candleStyle.wickDownColor": "#FF4D4D",
      });
      widget.setCSSCustomProperty('--tv-color-pane-background', '#000000');
      widget.setCSSCustomProperty('--tv-color-toolbar-button-text', '#FFFFFF');



      chart.createStudy('SPX Market GEX', false, false, {
        offset: 0,
        source: 'spxGexData',
      });

      chart.createStudy('SPX Gamma Volatility Indicator', false, false, {
        offset: 0,
        source: 'vvixData',
      });

      chart.createStudy('SR Levels Indicator', false, false, {
        source: 'originalSRData',
      });

      chart.createStudy('Raw GEX', false, false, {
        source: 'spxGexData',
      });
    });

    chartWidget.current = widget;
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        maxWidth: '100vw',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <div
        id="chartContainer"
        style={{
          flex: 1,
          border: '1px solid #333',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      ></div>
    </div>
  );
};

export default AdvancedMarketStateDashboard;


























































































